<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/account' }">账户列表</el-breadcrumb-item>
            <el-breadcrumb-item>编辑账户</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="账号名" prop="username">
                    <el-col :span="8">
                        <el-input v-model="form.username"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-col :span="8">
                        <el-input type="password" v-model="form.password"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="账户类型" prop="type">
                    <el-select v-model="form.type" placeholder="请选择">
                        <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交更新</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import accountApi from "../../api/account";
    import enterpriseApi from "../../api/enterprise";
    export default {
        data: function () {
            return {
                form: {
                    useableCount: 0
                },
                enterprises: [],
                loading: false,
                types:[
                    {
                        name: "操作员",
                        value: 1
                    },
                    {
                        name: "业务员",
                        value: 2
                    },
                    {
                        name: "管理员",
                        value: 3
                    },
                ],
                rules: {
                    epId: [{required: true, message: "请选择所属企业", trigger: "blur"}],
                    username: [{required: true, message: "请输入账号名称", trigger: "blur"}],
                    type: [{required: true, message: "请选择账户类型", trigger: "blur"}],
                },
            }
        },
        mounted: function() {
            this.loadDevice();
        },
        methods: {
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    accountApi.update(this.form).then(result => {
                        loading.close();
                        this.$message({
                            type: 'success',
                            message: '更新成功!'
                        });
                        this.$router.back();
                    })
                })

            },
            loadDevice: function () {
                accountApi.findById(this.$route.query.id).then(data => {
                    this.form = { ...data, password: ""};

                })
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;
                })
            }
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
